<form
  class="formCard"
  [formGroup]="formularioTurno"
  (ngSubmit)="guardarTurno()"
>
  <div class="tituloModal">
    <span class="tituloTexto" *ngIf="!editar">Agendar turno</span>
    <span class="tituloTexto" *ngIf="editar">{{
      turnoViejo ? "Información del turno" : "Editar turno"
    }}</span>

    <div class="accionModal" *ngIf="accionesEnHeader">
      <ng-container *ngTemplateOutlet="accionesTurno"></ng-container>
    </div>

    <mat-icon class="buttonClose" [mat-dialog-close]="false">close</mat-icon>
  </div>

  <div class="textModal">
    <div class="formGroup" *ngIf="!turnoDesdePaciente">
      <mat-form-field
        appearance="fill"
        class="example-full-width input"
        [ngClass]="tipoUsuario == 'paciente' ? 'readonlyBlock' : ''"
      >
        <mat-label>Paciente</mat-label>
        <mat-select
          formControlName="id_paciente"
          [placeholder]="'Paciente'"
          (ngModelChange)="validarPacienteEmail($event)"
        >
          <mat-option>
            <ngx-mat-select-search
              id="pacienteBuscador"
              [noEntriesFoundLabel]="'Not found'"
              [placeholderLabel]="'Buscador'"
              formControlName="pacienteBuscador"
              name="filterPost"
              (ngModelChange)="filtrarPaciente($event)"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let element of filtroPacientes"
            [value]="element.id"
          >
            <div class="optionCM">
              <div class="nombreSelect">{{ element.name }} {{ element.surname }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="valid">
        <span
          class="advertenciaMensaje"
          *ngIf="pacienteSeleccionado && !pacienteSeleccionado?.email"
        >
          <mat-icon class="advertenciaIcono">report_problem</mat-icon>El
          paciente selecionado no tiene email, no le llegaran notificaciones que
          pueden ser importantes
        </span>
        <span
          style="color: rgba(229, 57, 53)"
          *ngIf="
            formularioTurno.get('id_paciente').errors?.required &&
            formularioTurno.get('id_paciente').touched
          "
        >
          El paciente es requerido
        </span>
      </div>
    </div>

    <div
      class="formGroup"
      *ngIf="
        (tipoUsuario === 'medico' && listaCentrosMedicos.length > 1) ||
        tipoUsuario !== 'medico'
      "
    >
      <mat-form-field appearance="fill" class="example-full-width input">
        <mat-label>Centro médico</mat-label>
        <mat-select
          formControlName="centroMedico"
          [placeholder]="'Centro médico'"
          (ngModelChange)="validarCentroMedico($event)"
        >
          <mat-option>
            <ngx-mat-select-search
              id="centroMedicoBuscador"
              [noEntriesFoundLabel]="'Not found'"
              [placeholderLabel]="'Buscador'"
              formControlName="centroMedicoBuscador"
              name="filterPost"
              (ngModelChange)="filtrarCentroMedico($event)"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="0">
            <div class="optionCM">
              <div class="nombreSelect">Elegir centro médico</div>
            </div>
          </mat-option>
          <mat-option
            *ngFor="let element of filtroCentroMedicos"
            [value]="element.id"
          >
            <div class="optionCM">
              <div class="nombreSelect">{{ element.nombre }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="valid">
        <span
          style="color: rgba(229, 57, 53)"
          *ngIf="
            formularioTurno.get('centroMedico').errors?.required &&
            formularioTurno.get('centroMedico').touched
          "
        >
          El centro médico es requerido
        </span>
      </div>
    </div>
    <div
      class="formGroup"
      *ngIf="tipoUsuario !== 'medico' && centroMedicoSeleccionado"
    >
      <mat-form-field
        appearance="fill"
        class="example-full-width input"
        [ngClass]="tipoUsuario == 'medico' ? 'readonlyBlock' : ''"
      >
        <mat-label>Especialidad</mat-label>
        <mat-select
          formControlName="especialidad"
          [placeholder]="'Especialidad'"
          (ngModelChange)="filtrarEspecialidadMedico($event)"
        >
          <mat-option>
            <ngx-mat-select-search
              id="especialidadBuscador"
              [noEntriesFoundLabel]="'Not found'"
              [placeholderLabel]="'Especialidad'"
              formControlName="especialidadBuscador"
              name="filterPost"
              (ngModelChange)="filtrarEspecialidad($event)"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option [value]="0">
            <div class="optionCM">
              <div class="nombreSelect">Todas las especialidades</div>
            </div>
          </mat-option>
          <mat-option
            *ngFor="let element of filtroEspecialidades"
            [value]="element.id"
          >
            <div class="optionCM">
              <div class="nombreSelect">{{ element.texto }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="formGroup"
      *ngIf="mostrarServicioSelect && centroMedicoSeleccionado"
    >
      <mat-form-field appearance="fill" class="example-full-width input">
        <mat-label>Servicio</mat-label>
        <mat-select
          formControlName="servicio"
          [placeholder]="'Servicio'"
          [disabled]="servicioFijo"
          [compareWith]="compararServicio"
          (ngModelChange)="seleccionarServicio($event)"
        >
          <mat-option *ngFor="let serv of listaServicios" [value]="serv.id">
            <div class="optionCM">
              <div class="nombreSelect">{{ serv.nombre }} - {{ serv.duracion }}hs - ${{ serv.valor }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="formGroup"
      *ngIf="centroMedicoSeleccionado && tipoUsuario !== 'medico'"
    >
      <mat-form-field
        appearance="fill"
        class="example-full-width input"
        [ngClass]="tipoUsuario == 'medico' ? 'readonlyBlock' : ''"
      >
        <mat-label>Médico</mat-label>
        <mat-select
          formControlName="id_medico"
          [placeholder]="'Médico'"
          (ngModelChange)="validarMedicoEmail($event)"
        >
          <mat-option>
            <ngx-mat-select-search
              id="medicoBuscador"
              [noEntriesFoundLabel]="'Not found'"
              [placeholderLabel]="'Buscador'"
              formControlName="medicoBuscador"
              name="filterPost"
              (ngModelChange)="filtrarMedico($event)"
            >
            </ngx-mat-select-search>
          </mat-option>
          <mat-option
            *ngFor="let element of filtroMedicos"
            [value]="element.id"
          >
            <div class="optionCM">
              <div class="nombreSelect">{{ element.nombreCompleto }}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div class="valid">
        <span
          class="advertenciaMensaje"
          *ngIf="
            medicoSelecionado &&
            !medicoSelecionado?.email &&
            !turnoDesdePaciente
          "
        >
          <mat-icon class="advertenciaIcono">report_problem</mat-icon>El médico
          selecionado no tiene email, no le llegaran notificaciones que pueden
          ser importantes
        </span>
        <span
          style="color: rgba(229, 57, 53)"
          *ngIf="
            formularioTurno.get('id_medico').errors?.required &&
            formularioTurno.get('id_medico').touched
          "
        >
          El médico es requerido
        </span>
      </div>
      <div
        class="horarioMedico"
        *ngIf="medicoSelecionado && getAgendaActual() && !turnoViejo"
      >
        <span class="horario">Horario de médico</span>
        <div
          *ngIf="getAgendaActual().lunes_desde && getAgendaActual().lunes_hasta"
        >
          Lunes {{ getAgendaActual().lunes_desde }} -
          {{ getAgendaActual().lunes_hasta }}
          <ng-container *ngIf="getAgendaActual().lunes_desde_2 && getAgendaActual().lunes_hasta_2">
            / {{ getAgendaActual().lunes_desde_2 }} - {{ getAgendaActual().lunes_hasta_2 }}
          </ng-container>
        </div>
        <div
          *ngIf="
            getAgendaActual().martes_desde && getAgendaActual().martes_hasta
          "
        >
          Martes {{ getAgendaActual().martes_desde }} -
          {{ getAgendaActual().martes_hasta }}
          <ng-container *ngIf="getAgendaActual().martes_desde_2 && getAgendaActual().martes_hasta_2">
            / {{ getAgendaActual().martes_desde_2 }} - {{ getAgendaActual().martes_hasta_2 }}
          </ng-container>
        </div>
        <div
          *ngIf="
            getAgendaActual().miercoles_desde &&
            getAgendaActual().miercoles_hasta
          "
        >
          Miercoles {{ getAgendaActual().miercoles_desde }} -
          {{ getAgendaActual().miercoles_hasta }}
          <ng-container *ngIf="getAgendaActual().miercoles_desde_2 && getAgendaActual().miercoles_hasta_2">
            / {{ getAgendaActual().miercoles_desde_2 }} - {{ getAgendaActual().miercoles_hasta_2 }}
          </ng-container>
        </div>
        <div
          *ngIf="
            getAgendaActual().jueves_desde && getAgendaActual().jueves_hasta
          "
        >
          Jueves {{ getAgendaActual().jueves_desde }} -
          {{ getAgendaActual().jueves_hasta }}
          <ng-container *ngIf="getAgendaActual().jueves_desde_2 && getAgendaActual().jueves_hasta_2">
            / {{ getAgendaActual().jueves_desde_2 }} - {{ getAgendaActual().jueves_hasta_2 }}
          </ng-container>
        </div>
        <div
          *ngIf="
            getAgendaActual().viernes_desde && getAgendaActual().viernes_hasta
          "
        >
          Viernes {{ getAgendaActual().viernes_desde }} -
          {{ getAgendaActual().viernes_hasta }}
          <ng-container *ngIf="getAgendaActual().viernes_desde_2 && getAgendaActual().viernes_hasta_2">
            / {{ getAgendaActual().viernes_desde_2 }} - {{ getAgendaActual().viernes_hasta_2 }}
          </ng-container>
        </div>
        <div
          *ngIf="
            getAgendaActual().sabado_desde && getAgendaActual().sabado_hasta
          "
        >
          Sabado {{ getAgendaActual().sabado_desde }} -
          {{ getAgendaActual().sabado_hasta }}
          <ng-container *ngIf="getAgendaActual().sabado_desde_2 && getAgendaActual().sabado_hasta_2">
            / {{ getAgendaActual().sabado_desde_2 }} - {{ getAgendaActual().sabado_hasta_2 }}
          </ng-container>
        </div>
        <div
          *ngIf="
            getAgendaActual().domingo_desde && getAgendaActual().domingo_hasta
          "
        >
          Domingo {{ getAgendaActual().domingo_desde }} -
          {{ getAgendaActual().domingo_hasta }}
          <ng-container *ngIf="getAgendaActual().domingo_desde_2 && getAgendaActual().domingo_hasta_2">
            / {{ getAgendaActual().domingo_desde_2 }} - {{ getAgendaActual().domingo_hasta_2 }}
          </ng-container>
        </div>
      </div>
    </div>

    <div
      class="formGroup"
      *ngIf="!editar && centroMedicoSeleccionado && medicoSelecionado"
    >
      <mat-slide-toggle
        formControlName="modoRango"
        color="primary"
      >
        Agendar por rango de fechas
      </mat-slide-toggle>
    </div>

    <div *ngIf="!formularioTurno.value.modoRango" class="divDoble">
      <div
        class="formGroup"
        *ngIf="
          (turnoDesdePaciente && centroMedicoSeleccionado) ||
          !turnoDesdePaciente
        "
      >
        <mat-form-field appearance="fill" class="input">
          <mat-label>Fecha</mat-label>
          <input
            formControlName="fechaDesde"
            matInput
            [matDatepickerFilter]="boundedFiltrarFechasDatePicker"
            [matDatepicker]="fechaDesde"
            (ngModelChange)="cambiarTurno($event, 'fechaDesde')"
            [min]="diaActual"
            disabled
          />
          <mat-datepicker-toggle matSuffix [for]="fechaDesde">
          </mat-datepicker-toggle>
          <mat-datepicker
            #fechaDesde
            [disabled]="
              !medicoSelecionado ||
              (tipoUsuario === 'medico' && !centroMedicoSeleccionado) || turnoViejo
            "
          ></mat-datepicker>
        </mat-form-field>
        <div class="valid">
          <span
            style="color: rgba(229, 57, 53)"
            *ngIf="
              formularioTurno.get('fechaDesde').errors?.required &&
              formularioTurno.get('fechaDesde').touched
            "
          >
           La fecha es requerida
          </span>
        </div>
      </div>
      <div class="formGroup" *ngIf="centroMedicoSeleccionado">
        <mat-form-field appearance="fill" class="input">
          <mat-label>Horarios</mat-label>
          <mat-select
            [disabled]="!medicoSelecionado || !formularioTurno.value.fechaDesde"
            (selectionChange)="seleccionarHorario($event)"
            formControlName="tiempoDesde"
          >
            <ng-container *ngIf="medicoSelecionado">
              <mat-option
                *ngFor="let turno of listaDeTurnosSinLosYaOtorgados()"
                [value]="turno"
              >
                {{ turno }}
              </mat-option>
            </ng-container>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div *ngIf="formularioTurno.value.modoRango" class="rangoSection">
      <div class="divDoble">
        <div class="formGroup">
          <mat-form-field appearance="fill" class="input">
            <mat-label>Fecha desde</mat-label>
            <input
              matInput
              [matDatepicker]="rangoDesdePicker"
              formControlName="rangoFechaDesde"
              [min]="diaActual"
            />
            <mat-datepicker-toggle matSuffix [for]="rangoDesdePicker"></mat-datepicker-toggle>
            <mat-datepicker #rangoDesdePicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="formGroup">
          <mat-form-field appearance="fill" class="input">
            <mat-label>Fecha hasta</mat-label>
            <input
              matInput
              [matDatepicker]="rangoHastaPicker"
              formControlName="rangoFechaHasta"
              [min]="formularioTurno.value.rangoFechaDesde || diaActual"
            />
            <mat-datepicker-toggle matSuffix [for]="rangoHastaPicker"></mat-datepicker-toggle>
            <mat-datepicker #rangoHastaPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="formGroup">
        <mat-form-field appearance="fill" class="example-full-width input">
          <mat-label>Día de la semana</mat-label>
          <mat-select
            formControlName="diasSemanaRango"
            [placeholder]="'Días de la semana'"
            [multiple]="true"
          >
            <mat-option *ngFor="let dia of diasSemanaOpcionesDisponibles" [value]="dia.valor">
              {{ dia.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="formGroup">
        <mat-form-field appearance="fill" class="example-full-width input">
          <mat-label>Horario</mat-label>
          <mat-select
            formControlName="horaDesdeRango"
            [disabled]="!diasSemanaRangoTienenAgenda()"
          >
            <mat-option *ngFor="let turno of listaHorariosRango()" [value]="turno">
              {{ turno }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <div
          *ngIf="formularioTurno.value.diasSemanaRango?.length > 0
                 && diasSemanaRangoTienenAgenda()
                 && listaHorariosRango().length === 0"
          class="errorDiv"
        >
          Los días elegidos no comparten horarios. Ajustá la selección de días.
        </div>
        <div class="valid">
          <span
            class="advertenciaMensaje"
            *ngIf="
              formularioTurno.value.diasSemanaRango?.length > 0 &&
              !diasSemanaRangoTienenAgenda()
            "
          >
            <mat-icon class="advertenciaIcono">report_problem</mat-icon>
            El médico no tiene agenda configurada para ese día de la semana.
          </span>
        </div>
      </div>
    </div>

    <div class="formGroup" *ngIf="!turnoDesdePaciente && medicoSelecionado">
      <mat-form-field class="example-full-width input" appearance="fill">
        <mat-label>Detalle</mat-label>
        <textarea
          formControlName="detalle"
          class="textarea"
          type="text"
          matInput
        ></textarea>
      </mat-form-field>
      <div class="valid">
        <span
          style="color: rgba(229, 57, 53)"
          *ngIf="
            formularioTurno.get('detalle').errors?.required &&
            formularioTurno.get('detalle').touched
          "
        >
          El detalle es requerido
        </span>
      </div>
    </div>
    <div class="validError">
      <span style="color: rgba(229, 57, 53)" *ngIf="fechaError">
        {{ fechaError }}
      </span>
    </div>

    <mat-card *ngIf="hayQueMostrarPanelPagos" class="pagosCard">
      <mat-card-header>
        <mat-card-title class="pagosCardTitle">Estado de pagos</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div *ngIf="servicioPago" class="pagosResumen">
          Servicio: <strong>{{ servicioPago.nombre }}</strong> — Total
          <strong>${{ servicioPago.valor | number:'1.2-2' }}</strong>
          (reserva {{ servicioPago.porcentaje_reserva }}%)
        </div>

        <div class="pagosLista">
          <div *ngFor="let pago of pagosTurno" class="pagoItem pagoItem--{{ pago.estado }}">
            <mat-icon>
              {{ pago.estado === 'pagado' ? 'check_circle' :
                 pago.estado === 'pendiente' ? 'schedule' :
                 pago.estado === 'fallido' ? 'error' : 'restore' }}
            </mat-icon>
            <div class="pagoInfo">
              <div class="pagoTipo">
                {{ pago.tipo === 'reserva' ? 'Reserva' :
                   pago.tipo === 'saldo' ? 'Saldo' : 'Pago único' }}
              </div>
              <div class="pagoDetalle">
                ${{ pago.monto | number:'1.2-2' }} —
                {{ pago.estado }}
                <span *ngIf="pago.paid_at"> ({{ pago.paid_at | date:'dd/MM/yyyy HH:mm' }})</span>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="puedeEnviarLinkSaldo" class="pagosAcciones">
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="enviandoLinkSaldo"
            (click)="enviarLinkSaldo()"
          >
            {{ saldoPendiente ? 'Reenviar link de saldo' : 'Enviar link de saldo' }}
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="accionModal pie" *ngIf="!accionesEnHeader">
    <ng-container *ngTemplateOutlet="accionesTurno"></ng-container>
  </div>
</form>

<ng-template #accionesTurno>
  <div class="buttons" *ngIf="!turnoViejo">
    <button
      *ngIf="!editar"
      mat-raised-button
      color="warn"
      [mat-dialog-close]="true"
      type="button"
    >
      Cancelar
    </button>

    <button
      *ngIf="!editar"
      mat-raised-button
      color="primary"
      [disabled]="
        (!formularioTurno.value.modoRango && formularioTurno.value.tiempoDesde === 'No quedan turnos disponibles') ||
        (formularioTurno.value.modoRango && !formularioRangoValido())
      "
    >
      {{ formularioTurno.value.modoRango ? 'Crear rango' : 'Crear' }}
    </button>

    <button
      *ngIf="editar"
      [disabled]="turno.confirmado == 1 && tipoUsuario == 'paciente' && formularioTurno.invalid "
      mat-raised-button
      color="primary"
      type="submit"
    >
      Editar
    </button>

    <button
      *ngIf="editar"
      [disabled]="turno.confirmado == 1 && tipoUsuario == 'paciente'"
      mat-raised-button
      color="warn"
      type="button"
      (click)="borrarTurno()"
    >
      Borrar
    </button>
  </div>
</ng-template>
